<template>
  <el-drawer
    v-model="drawer"
    :z-index="99"
    class="musicDetail"
    :class="{
      custom: !isSelf,
      'custom-video': !isSelf && !renderData.curPlayData?.video?.video_url,
      'musicDetail-app': isFromApp,
    }"
    direction="btt"
    :with-header="false"
  >
    <CallAppBanner
      @download="onDownload"
      :shareKey="shareKey"
      v-if="isFromApp"
    />
    <MusicDetail
      :title="renderData.curPlayData?.title"
      :name="renderData.curPlayData?.user?.stage_name"
      :avatar="
        renderData.curPlayData?.user?.profile_image &&
        getObjectStorageFullUrl(renderData.curPlayData?.user?.profile_image)
      "
      :data="renderData.curPlayData"
      :segments="renderData.curPlayData?.lyrics"
      :duration="renderData.curPlayData?.duration_milliseconds"
      :url="renderData.url"
      :coverUrl="renderData.curPlayData?.cover"
      :isFromShare="isFromShare"
      :isFromApp="isFromApp"
      :isLogin="userDataStore.isLogin"
      :progress="renderData.progress"
      :isSelf="isSelf"
      @close="closeMusicDetail"
      @syncProgress="syncProgress"
      :isCurPlay="renderData.isCurPlay"
      :notFound="props.notFound"
      :isGenerating="renderData.isGenerating"
    >
      <GlobalPlayer
        :highPosition="
          renderData.curPlayData?.is_regenerate
            ? renderData.curPlayData?.regenerate_from / 1000
            : null
        "
        ref="refGloblePlayer"
        :url="renderData.url"
        :loop="renderData.loop"
        @syncProgress="syncProgress"
        @syncPlayState="syncPlayState"
        @switch="doSwitch"
        @play="doPlay"
        :duration="renderData.duration"
        v-model:isGenerating="renderData.isGenerating"
      />
      <ReportDialog
        v-if="reportDialogVisible"
        v-model:visible="reportDialogVisible"
        :data="renderData.curPlayData"
        :reportType="4"
      ></ReportDialog>
      <div class="audio-palyer-right flex">
        <AudioItem
          v-if="renderData.item"
          :item="renderData.item"
          :pitem="renderData.pitem"
          :isSelf="isSelf"
          @like="(pitem, item) => changeFavorite(item, item?.is_liked ? 1 : 2)"
          renderType="createdetail"
          @doPlayVideo="doPlayVideo"
          @delete="deleteSong"
          @handleSimilar="handleSimilar"
        />
        <!-- <template v-if="isSelf">
          <div
            v-if="$$language() == 'cn'"
            class="audio-item-ico-btn ico-btn pointer flex-center"
          >
            <Report
              :song-id="renderData.curPlayData?.song_id"
              position="top"
              @handleReport="handleReport"
            ></Report>
          </div>
        </template>
        <template v-else>
          <div
            class="share-btn"
            :class="{
              disabled: isDisableByAudit(),
            }"
            @click="
              () => {
                if (!isDisableByAudit()) {
                  doShare();
                }
              }
            "
          >
            {{ $$t("store.copyLinkButton") }}
          </div>
        </template> -->
        <!-- <div
          class="cover-img-op-share-btn flex-center"
          v-if="!isSelf"
          :class="{
            disabled: isDisableByAudit(),
            'cover-img-op-share-btn-no': !(
              ModuleOpenStateControl.home.similar &&
              !isSelf &&
              renderData.curPlayData?.generation_method != 7
            ),
          }"
          @click="
            () => {
              if (!isDisableByAudit()) {
                doShare();
              }
            }
          "
        >
          <i class="block"></i>
        </div>
        <div
          class="cover-img-op-similar-btn"
          v-if="
            ModuleOpenStateControl.home.similar &&
            !isSelf &&
            renderData.curPlayData?.generation_method != 7
          "
        >
          <Button
            :disabled="renderData.isGenerating"
            @click="handleSimilar"
            :renderStyle="{
              '--padding': '0 20px',
              '--width': '100%',
              '--height': '44px',
              '--borderRadius': '50px',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background': 'rgba(255, 255, 255, 0.2)', //#94ADFF
              '--backgroundHover': 'rgba(255, 255, 255, 0.3)',
              '--fontColorHover': '#fff',
            }"
          >
            {{ $$t("create.create_similar") }}
          </Button>
        </div> -->
      </div>
    </MusicDetail>
  </el-drawer>
</template>

<script setup>
import {
  ref,
  reactive,
  watch,
  getCurrentInstance,
  watchEffect,
  onUnmounted,
  onMounted,
  defineEmits,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { $$language, $$t } from "@/i18n/i18n.js";
import MusicDetail from "./mobileMusicDetail.vue";
import message from "@/components/functionCallComponent/message/message.js";
import Report from "@/components/report/report.vue";
import GlobalPlayer from "@/components/media/audioPlayer/MobileGloblePlayer.vue";

import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import useUserDataStore from "@/store/userDataStore";
import useShopCartStore from "@/store/shopCartStore.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";

import useStoreDetailData from "@/store/storeDetail/storeDetailDataStore.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import ReportDialog from "@/components/report/reportDialog.vue";
import useCreateRenderType from "@/store/create/createLayoutStore.js";
import AudioItem from "@/page/create/feedList/audioItem.vue";
import useDiscoverDataStore from "@/store/discover/discoverDataStore.js";
import CallAppBanner from "./callAppBanner.vue";
import GlobalAudioPlayer from "@/components/media/audioPlayer/GlobalAudioPlayer.js";
import globleConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

const route = useRoute();
const router = useRouter();
const globalPlayDataStore = useGlobalPlayDataStore();
const userDataStore = useUserDataStore();
const shopCartStore = useShopCartStore();
const storeDetailDataStore = useStoreDetailData();
const createRenderType = useCreateRenderType();
const discoverDataStore = useDiscoverDataStore();
const feedListDataStore = useFeedListStore();

const { toggleCreateEditOpenState } = createRenderType;

const refGloblePlayer = ref(null);
const drawer = ref(false);

const isSelf = computed(() => {
  const isUserDataUser = userDataStore.userInfo?.user?.user_id;
  const isDataUser = renderData.curPlayData?.user?.user_id;
  return (isUserDataUser || false) && isUserDataUser === isDataUser;
});

const emits = defineEmits(["handleSimilar", "deleteSong"]);

const props = defineProps({
  notFound: {
    type: Boolean,
    default: false,
  },
});

const renderData = reactive({
  curPlayData: {},
  item: null,
  pitem: {},
  url: "",
  duration: 0,
  startTime: 0,
  progress: 0,
  title: "",
  name: "",

  loop: false,
  isPlaying: false,
  tempToggleStatus: false,
  curPlayGroup: "",
  shareSuccessText: "",
  isCurPlay: false,
  isGenerating: false,
  lastPlaySong: null,
});

const isFromShare = ref(false);
const isFromApp = ref(false);
const shareKey = ref(route.query.share_key);

const reportDialogVisible = ref(false);

const handleReport = () => {
  reportDialogVisible.value = true;
};

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const deleteSong = () => {
  emits("deleteSong");
};

const doPlayVideo = () => {
  globalProperties.logClickEvent("song_detail_page_video", {
    type: isSelf.value ? "active_state " : "passive_state",
  });
};

const closeMusicDetail = () => {
  // 如果已经登录，且是商店的歌曲，回到商店
  if (
    isFromShare.value &&
    userDataStore.isLogin &&
    renderData.curPlayData?.sold_state
  ) {
    router.push({
      name: "store",
    });
  } else if (isFromShare.value) {
    // 如果是分享页，且没有登录，回到创作页
    toggleCreateEditOpenState(true);
    router.push({
      name: "create",
    });
  } else {
    router.back();
  }
};

const toggleLoop = () => {
  renderData.loop = !renderData.loop;
};

const renderType = (sold_state, audit_state) => {
  if (audit_state != 1) {
    return $$t("library.Notforsale");
  }
  if (sold_state == 2) {
    return $$t("library.Suspend");
  } else if (sold_state == 3) {
    return $$t("library.Soldout");
  } else if (sold_state == 1) {
    return $$t("store.checkout");
  } else {
    return $$t("library.Notforsale");
  }
};

const isDisableByAudit = () => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4, 5].includes(renderData.curPlayData?.machine_audit_state) ||
    [4].includes(renderData.curPlayData?.publish_state) ||
    renderData.curPlayData?.machine_state == 4
  );
};

const doSwitch = (data) => {
  globalPlayDataStore.switchSong(data).then((curPlayData) => {
    setTimeout(async () => {
      // if (!renderData.isPlaying) {
      //   await GlobalAudioPlayer.play(getAudioUrl(curPlayData));
      // }
      GlobalAudioPlayer.seek(getAudioUrl(curPlayData), 0);
    }, 10);

    if (route.name == "songDetail" || route.name == "songDetailOld") {
      router.replace({
        name: "songDetail",
        params: {
          source: "switch",
          song_id: curPlayData?.song_id,
        },
        query: {
          ...(route.params?.from || route.query?.from
            ? { from: route.params?.from || route.query?.from }
            : {}),
        },
      });
    } else {
      // router.push({
      //   name: "songDetail",
      //   query: {
      //     source: "switch",
      //   },
      //   params: {
      //     song_id: curPlayData?.song_id,
      //   }
      // });
    }
  });
};

const syncProgress = (progress, startTime) => {
  renderData.progress = progress;
  renderData.startTime = startTime;
};

const syncPlayState = (isPlaying) => {
  console.log("🙂", isPlaying);
  renderData.isPlaying = isPlaying;
  if (renderData.curPlayData && renderData.isPlaying) {
    const song_id = renderData.curPlayData?.song_id;
    if (!renderData.curPlayData?.is_played) {
      feedListDataStore
        .doReportPlayedState(renderData.pitem, renderData.curPlayData)
        .then(() => {
          if (song_id == renderData.curPlayData?.song_id) {
            renderData.curPlayData.is_played = true;
          }
        });
    }
  }
  // globalPlayDataStore.setIsPlaying(isPlaying);
};

const changeFavorite = (data, state) => {
  discoverDataStore.updateGlobalPlayFavorite(data.song_id, state);
  shopCartStore.updateShopLike(data.song_id, state);
  storeDetailDataStore.updateDetail({
    ...renderData.curPlayData,
    favorite_state: state,
    is_liked: state === 1 ? true : false,
  });
  globalPlayDataStore.updatePlayDataItem({
    ...renderData.curPlayData,
    favorite_state: state,
    is_liked: state === 1 ? true : false,
  });
  if (!isSelf.value) {
    globalProperties.logClickEvent("song_like", {
      entity: "song_like",
      content_id: renderData.curPlayData?.song_id,
    });
  }
};

const doShare = () => {
  // 处理分享逻辑
  renderData.shareSuccessText = "";
  globalPlayDataStore.doShare(renderData.curPlayData).then((isSuccess) => {
    renderData.shareSuccessText = $$t("store.copyLinkSuccess");
    message.success({
      position: "top",
      content: $$t("store.copyLinkSuccess"),
    });
    globalProperties.logClickEvent("song_copy_link", {
      content_id:
        renderData.curPlayData?.song_id ??
        renderData.curPlayData?.song?.song_id ??
        "",
      source: "player",
    });
  });

  if (!isSelf.value) {
    globalProperties.logClickEvent("song_copy_link", {
      entity: "song_copy_link",
      content_id: renderData.curPlayData?.song_id,
    });
  }
};

const handleSimilar = () => {
  emits("handleSimilar", renderData.curPlayData);
};

const getAudioUrl = () => {
  if (
    (globalPlayDataStore.curPlayData?.stream_key &&
      GlobalAudioPlayer.currentUrl ==
        getPipeReadableFlowUrl(globalPlayDataStore.curPlayData?.stream_key) &&
      GlobalAudioPlayer.players[GlobalAudioPlayer.currentUrl]?.isPlaying) ||
    !globalPlayDataStore.curPlayData?.mp3_url
  ) {
    return getPipeReadableFlowUrl(globalPlayDataStore.curPlayData?.stream_key);
  } else {
    return getObjectStorageFullUrl(globalPlayDataStore.curPlayData?.mp3_url);
  }
};

const initFlowData = async () => {
  if (ModuleOpenStateControl.create.generatingStream) {
    if (
      globalPlayDataStore.curPlayData?.song_id ==
      renderData.curPlayData?.song_id
    ) {
      renderData.url = getAudioUrl();
      renderData.isGenerating =
        !/\.[0-9A-Za-z]{1,}$/.test(
          globalPlayDataStore.curPlayData?.mp3_url ?? ""
        ) && globalPlayDataStore.curPlayData?.stream_key;

      if (renderData.curPlayData?.duration_milliseconds > 0) {
        renderData.duration =
          (renderData.curPlayData?.duration_milliseconds ?? 0) / 1000;
      }
    }
  }
};

watch(
  () => globalPlayDataStore.curPlayData,
  (newVal) => {
    initFlowData();
  },
  {
    immediate: true,
  }
);

// watch(
//   () => globalPlayDataStore.curPlayData,
//   (newVal) => {
//     if (!newVal) {
//       return;
//     }
//     renderData.curPlayData = globalPlayDataStore.curPlayData;
//     renderData.url = getObjectStorageFullUrl(globalPlayDataStore.curPlayData?.mp3_url);
//     renderData.duration =
//       (globalPlayDataStore.curPlayData?.duration_milliseconds ?? 0) / 1000;
//     renderData.title = globalPlayDataStore.curPlayData?.title;
//   }
// )
// watch(
//   () => globalPlayDataStore.tempToggleStatus,
//   () => {
//     renderData.tempToggleStatus = globalPlayDataStore.tempToggleStatus;
//     if (renderData.tempToggleStatus) {
//       refGloblePlayer.value.changeTempOp(false);
//     } else {
//       refGloblePlayer.value.changeTempOp(true);
//     }
//   }
// );

// watch(
//   () => globalPlayDataStore.isPlaying,
//   (isPlaying) => {
//     if (renderData.isPlaying != isPlaying) {
//       refGloblePlayer.value.changeOp(isPlaying);
//       renderData.isPlaying = isPlaying;
//     }
//   }
// );

// watch(
//   () => globalPlayDataStore.curPlayGroup,
//   () => {
//     renderData.curPlayGroup = globalPlayDataStore.curPlayGroup;
//     console.log(
//       "🚀 ~ file: mobileStoreDetail.vue ~ line 202 ~ watch ~ renderData.curPlayGroup",
//       renderData.curPlayGroup
//     );
//   },
//   { immediate: true }
// );

const changeUrlListenerListener = () => {
  renderData.isCurPlay =
    GlobalAudioPlayer.currentUrl ==
    `${getObjectStorageFullUrl(renderData.url)}`;
};

// 直接从detailData获取
watch(
  () => storeDetailDataStore.info,
  (newVal) => {
    if (!newVal) return;
    renderData.curPlayData = newVal;
    renderData.item = Object.assign({}, renderData.curPlayData ?? {});
    renderData.pitem = {
      feed_id: renderData.curPlayData?.feed_id,
      songs: [renderData.item],
      is_generated_from_uploaded_file:
        renderData.curPlayData?.is_generated_from_uploaded_file,
      generation_method: renderData.curPlayData?.generation_method,
      model: renderData.curPlayData?.model,
      is_trimmed: renderData.curPlayData?.is_trimmed,
      state: renderData.curPlayData?.pstate,
      thinking_process_url: renderData.curPlayData?.thinking_process_url,
    };
    renderData.url = getAudioUrl();
    renderData.isGenerating =
      !/\.[0-9A-Za-z]{1,}$/.test(renderData.curPlayData?.mp3_url ?? "") &&
      renderData.curPlayData?.stream_key;
    if (newVal.duration_milliseconds > 0) {
      renderData.duration = newVal.duration_milliseconds / 1000;
    }
    renderData.title = newVal.title;
    changeUrlListenerListener();
    // 如果已经有播放列表，不再添加
    if (
      globalPlayDataStore.playlist?.length &&
      globalPlayDataStore.playlist?.[0]?.title
    ) {
      return;
    }
    globalPlayDataStore.setPlayDatas([newVal], newVal);
    initFlowData();
  },
  { immediate: true }
);

const isLogged = ref(false);

watchEffect(() => {
  if (storeDetailDataStore.info?.song_id && !isLogged.value) {
    isLogged.value = true;
    globalProperties.logViewEvent("song_detail_page", {
      entity: "song_detail_page",
      content_id: `${storeDetailDataStore.info?.song_id}`,
    });
  }
});

const doPlay = (url) => {
  // if (url == renderData.url) {
  //   globalPlayDataStore.setCurPlayData(renderData.curPlayData);
  // }
  globalProperties.logClickEvent("song_detail_page_play", {
    is_self: isSelf.value ? 1 : 2,
    entity: "song_detail_page_play",
    content_id: renderData.curPlayData?.song_id.toString(),
  });
};

onMounted(() => {
  GlobalAudioPlayer.registGlobleListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  changeUrlListenerListener();
  drawer.value = true;
  isFromShare.value = route?.query?.is_from_share == 1;
  isFromApp.value = route?.query?.from_app == "true";
  shareKey.value = route.query.share_key;
});
onUnmounted(() => {
  GlobalAudioPlayer.releaseGlobleListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  isLogged.value = false;
});
</script>

<style lang="scss" scoped>
.audio-palyer-right {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  margin: 15px -12px 0 -12px;
  :deep(.audio-item-createdetail-btns-box) {
    width: calc(100% + 24px);
    .audio-item-publish-btn {
      margin: 0 8px;
      button {
        width: 94px !important;
      }
    }
  }
  :deep(.audio-item-createdetail-btn) {
    flex-shrink: 0;
    width: 42px !important;
    height: 42px;
    // background: red;
    i {
      width: 24px;
      height: 24px;
    }
  }
}

.audio-item-ico-btn {
  width: 40px;
  height: 40px;

  i {
    display: block;
    width: 24px;
    height: 24px;
  }
}

.audio-item-like-status {
  i.like-false {
    background: url(@/assets/img/not-like-ico.png);
    background-size: 100% 100%;
  }

  i.like-true {
    background: url(@/assets/img/like-ico.png);
    background-size: 100% 100%;
  }
}

.audio-item-share {
  i {
    background: url(@/assets/img/share-ico.png);
    background-size: 100% 100%;
  }
}

.audio-item-buy {
  i.cart-false {
    background: url(@/assets/img/trolley-ico.png);
    background-size: 100% 100%;
  }

  i.cart-true {
    background: url(@/assets/img/trolley-red-ico.png);
    background-size: 100% 100%;
  }
  &.op {
    opacity: 0.3;
    &:hover {
      border-radius: 0;
      background-color: transparent;
    }
  }
}

.op-btn {
  opacity: 0.3;
}

:deep(.el-overlay) {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: transparent;
}

.globle-player-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  i {
    width: 24px;
    height: 24px;
  }
  i.repeat-true {
    background: url("@/assets/img/player/mode.svg");
    background-size: 100% 100%;
  }
  i.repeat-false {
    background: url("@/assets/img/circle-ico.png");
    background-size: 100% 100%;
  }

  i.cart-true {
    background: url("@/assets/img/player/cart.svg");
    background-size: 100% 100%;
  }
  i.cart-false {
    background: url("@/assets/img/player/cart.svg");
    background-size: 100% 100%;
  }
}

.share-btn {
  flex: 1;
  height: 44px;
  border-radius: 60px;
  background: rgba(255, 255, 255, 0.2);
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
}
.cover-img-op-share-btn {
  height: 44px;
  width: 44px;
  border-radius: 60px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  i {
    width: 24px;
    height: 24px;
    background: url(@/assets/img/share.png);
    background-size: 100% 100%;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
<style lang="scss">
.el-overlay {
  top: 0 !important;
  left: 0;
  right: 0;
  bottom: 0;
}
.musicDetail {
  height: 100% !important;
  min-height: 100% !important;
  background: linear-gradient(180deg, #5e6690 4%, #524376 100%) !important;
  backdrop-filter: blur(100px);
  color: #fff;
  .el-drawer__body {
    padding: 28px;
  }
  .detailWrapper {
    padding: 0;
  }
  &.custom {
    .audio-palyer-right {
      gap: 8px;
      .cover-img-op-similar-btn {
        flex: 1;
        width: 0;
        margin: 0 12px 0 8px;
      }
      .cover-img-op-share-btn {
      }
    }
    .audio-item-createdetail-btns-box {
      width: 100%;
    }
    .audio-item-createdetail-btns {
      .audio-item-publish-btn,
      .audio-item-createdetail-btn-download,
      .audio-item-createdetail-btn-more-box {
        display: none;
      }
    }
  }

  .audio-item-createdetail-btn-video {
    display: none;
  }

  &.custom-video {
    .audio-item-createdetail-btns {
      .audio-item-createdetail-btn-video {
        display: none;
      }
    }
  }
}
</style>
